import Icon from "./Icon";

function BlankState({ title, helper, iconName, primaryLabel = "Create new", secondaryLabel = "Import" }) {
  return (
    <section className="panel">
      <header className="panel-header">
        <div className="panel-title">
          <span className="panel-icon">
            <Icon name={iconName} />
          </span>
          <div>
            <h2>{title}</h2>
            <p className="muted">{helper}</p>
          </div>
        </div>
        <button className="ghost-btn">+ Add</button>
      </header>

      <div className="blank-state">
        <div className="blank-icon">
          <Icon name={iconName} />
        </div>
        <div className="blank-copy">
          <div className="blank-title">{title} screen</div>
          <p className="muted">
            This area is empty for now. When you start adding data, it will appear here with sorting, status, and actions.
          </p>
        </div>
        <div className="blank-actions">
          <button className="primary-btn ghost-tone">{primaryLabel}</button>
          <button className="ghost-btn subtle">{secondaryLabel}</button>
        </div>
      </div>
    </section>
  );
}

export default BlankState;
